// Fade in lazy-loaded images on load
(function () {
  if (!('IntersectionObserver' in window)) return;

  var style = document.createElement('style');
  style.textContent = 'img[loading="lazy"]{opacity:0;transition:opacity .4s ease}img[loading="lazy"].is-loaded{opacity:1}';
  document.head.appendChild(style);

  function onLoad(img) {
    img.classList.add('is-loaded');
  }

  function observe(img) {
    if (img.complete) {
      onLoad(img);
      return;
    }
    img.addEventListener('load', function () { onLoad(img); }, { once: true });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        observe(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });

  function init() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      observer.observe(img);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run for dynamically injected content (e.g. cart modal)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('img[loading="lazy"]')) observer.observe(node);
        node.querySelectorAll && node.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          observer.observe(img);
        });
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

// External links open in new tab
document.addEventListener('click', function (e) {
  var a = e.target.closest('a[href]');
  if (!a) return;
  var href = a.getAttribute('href');
  if (href && href.startsWith('http') && !href.includes(location.hostname)) {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  }
}, true);
